import React from 'react';

import type { GeneralEvent } from '@vlabs/api/luna-api/model';

import { BaseMap } from './BaseMap';
import { getMarker } from './getMarker';

interface GeneralEventMapProps {
  event?: GeneralEvent;
}

export function GeneralEventMap({ event = undefined }: GeneralEventMapProps): React.JSX.Element {
  const eventData = event?.event;
  const marker = getMarker(eventData);

  return (
    <BaseMap
      location={eventData?.location}
      markers={marker ? [marker] : []}
      streamId={eventData?.stream_id}
    />
  );
}
